const MONTH_CODES = {
    1: 'A', 2: 'B', 3: 'C', 4: 'D', 5: 'E', 6: 'H',
    7: 'L', 8: 'M', 9: 'P', 10: 'R', 11: 'S', 12: 'T',
};

const CHECK_CODE_ODD = {
    0: 1, 1: 0, 2: 5, 3: 7, 4: 9, 5: 13, 6: 15, 7: 17, 8: 19, 9: 21,
    A: 1, B: 0, C: 5, D: 7, E: 9, F: 13, G: 15, H: 17, I: 19, J: 21,
    K: 2, L: 4, M: 18, N: 20, O: 11, P: 3, Q: 6, R: 8, S: 12, T: 14,
    U: 16, V: 10, W: 22, X: 25, Y: 24, Z: 23,
};

const CHECK_CODE_EVEN = {
    0: 0, 1: 1, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6, 7: 7, 8: 8, 9: 9,
    A: 0, B: 1, C: 2, D: 3, E: 4, F: 5, G: 6, H: 7, I: 8, J: 9,
    K: 10, L: 11, M: 12, N: 13, O: 14, P: 15, Q: 16, R: 17, S: 18, T: 19,
    U: 20, V: 21, W: 22, X: 23, Y: 24, Z: 25,
};

function consonants(str) {
    return String(str).toUpperCase().replace(/[^BCDFGHJKLMNPQRSTVWXYZ]/g, '');
}

function vowels(str) {
    return String(str).toUpperCase().replace(/[^AEIOU]/g, '');
}

function codeFromSurname(part) {
    const cons = consonants(part);
    const vows = vowels(part);
    return (cons + vows + 'XXX').slice(0, 3);
}

function codeFromFirstName(part) {
    const cons = consonants(part);
    const vows = vowels(part);
    if (cons.length >= 4) {
        return `${cons[0]}${cons[2]}${cons[3]}`;
    }
    return (cons + vows + 'XXX').slice(0, 3);
}

function splitFullName(fullName) {
    const parts = String(fullName || '').trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0) return { firstName: '', lastName: '' };
    if (parts.length === 1) return { firstName: parts[0], lastName: parts[0] };
    return {
        firstName: parts.slice(0, -1).join(' '),
        lastName: parts[parts.length - 1],
    };
}

function birthDateCode(birthDate, gender) {
    const match = String(birthDate || '').trim().match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (!match) return null;
    const year = match[1].slice(-2);
    const monthNum = parseInt(match[2], 10);
    const dayNum = parseInt(match[3], 10);
    const month = MONTH_CODES[monthNum];
    if (!month || Number.isNaN(dayNum)) return null;
    let day = dayNum;
    if (String(gender).toUpperCase() === 'F') day += 40;
    return `${year}${month}${String(day).padStart(2, '0')}`;
}

function checkChar(code15) {
    let sum = 0;
    for (let i = 0; i < 15; i += 1) {
        const c = code15[i];
        sum += i % 2 !== 0 ? CHECK_CODE_EVEN[c] : CHECK_CODE_ODD[c];
    }
    return String.fromCharCode(65 + (sum % 26));
}

export function computeItalianFiscalCode({
    fullName,
    birthDate,
    gender,
    belfioreCode,
}) {
    const { firstName, lastName } = splitFullName(fullName);
    const placeCode = String(belfioreCode || '').trim().toUpperCase();
    if (!lastName || !firstName || !birthDate || !gender || placeCode.length !== 4) {
        return null;
    }
    const dateCode = birthDateCode(birthDate, gender);
    if (!dateCode) return null;

    const partial = (
        codeFromSurname(lastName)
        + codeFromFirstName(firstName)
        + dateCode
        + placeCode
    ).toUpperCase();

    if (partial.length !== 15) return null;
    return partial + checkChar(partial);
}

export async function generateItalianFiscalCodeFromProfile({
    fullName,
    birthDate,
    gender,
    birthPlace,
    birthPlaceZip,
    api = null,
}) {
    const { lookupBelfioreCode } = await import('./comuniLookup');
    const belfioreCode = await lookupBelfioreCode(birthPlace, birthPlaceZip, api);
    if (!belfioreCode || belfioreCode.length !== 4) return null;
    return computeItalianFiscalCode({
        fullName,
        birthDate,
        gender,
        belfioreCode,
    });
}
